'use strict';

var _ = require('lodash');
var Bluebird = require('bluebird');
function GridExportCSVService(fileSaveService) {
  function getHeaders(columnsHeaderMapToExport) {
    return Bluebird.resolve(_.map(columnsHeaderMapToExport, function (header) {
      return header;
    }));
  }
  function getRows(rows, columnsHeaderMapToExport) {
    return Bluebird.map(rows, function (row) {
      var orderedRow = _.reduce(_.keys(columnsHeaderMapToExport), function (acc, key) {
        acc[key] = row[key] || null;
        return acc;
      }, {});
      return _.map(orderedRow, function (propertyValue, property) {
        if (property === 'classNames' && !_.isEmpty(propertyValue)) {
          return '"' + propertyValue + '"';
        }
        return propertyValue;
      });
    });
  }
  function toCSV(row) {
    return row.join(',') + '\r\n';
  }
  function exportToCSV(rows, columnsHeaderMapToExport, fileName) {
    return Bluebird.join(getHeaders(columnsHeaderMapToExport), getRows(rows, columnsHeaderMapToExport)).then(function (results) {
      var csvContent = _.reduce(results[1], function (acc, row) {
        return acc + toCSV(row);
      }, toCSV(results[0]));
      fileSaveService.createFile(csvContent, 'text/csv', fileName);
    });
  }
  return {
    exportToCSV: exportToCSV
  };
}
GridExportCSVService.$inject = ['FileSaveService'];
module.exports = GridExportCSVService;